var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPintrestIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.102,
    height: 19.782,
    viewBox: "0 0 16.102 19.782",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_17259",
    "data-name": "Path 17259",
    d: "M71.028,62c-3.44.37-6.866,3.024-7,6.823-.091,2.319.877,4.057,3.189,4.546a12.407,12.407,0,0,0,.313-1.69,4.52,4.52,0,0,1-1.121-1.6c-.85-5,6.037-8.415,9.651-4.923,2.493,2.423.85,9.875-3.175,9.1-3.858-.74,1.887-6.669-1.191-7.836-2.5-.95-3.83,2.9-2.646,4.8-.7,3.282-2.193,6.376-1.588,10.489,1.971-1.362,2.632-3.974,3.175-6.7.989.573,1.518,1.173,2.778,1.264,4.651.342,7.249-4.435,6.615-8.848-.571-3.911-4.651-5.9-9-5.433Z",
    transform: "translate(-64.018 -61.937)",
    fill: "#fff"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPintrestIcon);
export default __webpack_public_path__ + "static/media/pintrest__icon.c49538bf15c8fa8f6210741fb87c7843.svg";
export { ForwardRef as ReactComponent };